import baseTableOne from './base-table-one'
baseTableOne.install = function (Vue) {
  Vue.component(baseTableOne.name, baseTableOne)
}
export default baseTableOne